import React, {useState} from 'react';

async function handlePersonData(id) {

    const fileName = `../data/${id}.json`;
    const fileImg = `../data/photos/${id}.png`;

    try {
        const response = await fetch(fileName); // 文件路径
        if (!response.ok) {
            throw new Error('读取数据出错');
        }
        const data = await response.json();

        const responseImg = await fetch(fileImg); // 文件路径
        if (!response.ok) {
            throw new Error('读取photo出错');
        }
        const photo = await responseImg;
        data.photo=photo

        return data;

    } catch (error) {
        console.error('读取JSON文件时出错：', error);
        return "";
    }
}

export default handlePersonData;
